import styled from 'styled-components';
import { Row, Col,Icon } from "antd";

export const ProcessingContainer = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  letter-spacing: ${props => props.theme.letterSpacing.point5};
  span {
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    margin-left: 0.5rem;
  }
  justify-content: space-between;
  & > div:last-child {
    align-self: center;
    span {
      letter-spacing: ${props => props.theme.letterSpacing.point6};
    };
  }

  @media only screen and (max-width: 991.92px) {
    flex-direction: column;
    & > div:nth-child(1) {
      & > div:last-child {
        & div:nth-child(1) {
          &:after {
            display: none;
          }
        }
      }
    }
    & > div:last-child {
      align-self: start;
      margin-top: 2rem;
    }
  }
`;

export const ViewContrLabel = styled(Col)`
font-family: ${props => props.theme.fontFamily.HelveticaNeue};
font-size: ${props => props.theme.fontSize.primary};
line-height: 1.5;
color: ${props => props.theme.fontColors.textColor};
white-space: nowrap;
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: ${props => props.theme.fontSize.secondary};
}
`
export const ViewContrValue = styled(Col)`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  color: ${props => props.theme.fontColors.headingColor};
  font-size: ${props => props.theme.fontSize.primary};
  margin-left: ${props=> props.marginLeft ? props.marginLeft : '0'};
  word-break: ${props => props.isWordBreak ? 'break-word' : 'normal'};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    word-break: ${props => props.isWordBreak ? 'break-all' : 'normal'};
  }
`

export const FlexCenter = styled(Col)`
display: flex;
align-items: ${props => props.isAccountName? 'start' : 'center'};
margin-right: 10px;
margin-bottom: ${props =>(props.marginBottom === undefined)? "0px": props.marginBottom};
@media only screen and (min-width: 320px) and (max-width: 767px) {
  margin-bottom: 5px;
}
`
export const SpaceBetween = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
`